import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchColors = () =>
  apiActionCreator({
    'endpoint': '/master-vehicles/colors',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MANAGE_COLORS,
      ActionTypes.FETCHED_MANAGE_COLORS,
      [ActionTypes.FETCHED_MANAGE_COLORS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const updateManageColors = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/master-vehicles/colors',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_MANAGE_COLORS,
        [
          () => {
            dispatch(fetchColors());
            return {
              'type': ActionTypes.UPDATED_MANAGE_COLORS,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Estado Actualizado'),
        ],
        [ActionTypes.UPDATED_MANAGE_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};
